import React from 'react';
import { Pane, toaster, BackButton } from 'evergreen-ui';
import PageHeader from 'components/shared/PageHeader';
import CreateOrUpdateEquipment from 'components/organizations/CreateOrUpdateEquipment';

export default ({ history, equipment, organization }: any) => {
  return (
    <>
      <PageHeader
        title="Update equipment"
        renderButtons={
          <BackButton
            marginLeft="auto"
            onClick={() => history.push(`/orgs/${organization.slug}/equipment`)}
          />
        }
      />
      <Pane width="500px">
        <CreateOrUpdateEquipment
          organizationId={organization.id}
          equipment={equipment}
          onComplete={() => {
            toaster.success('Equipment successfully updated');
            history.push(`/orgs/${organization.slug}/equipment`);
          }}
        />
      </Pane>
    </>
  );
};
